import _Vue from "vue";
import { CDN_BASE_URL } from "@/config/config";

declare module "vue/types/vue" {
  export interface Vue {
    $remoteImg: any;
  }
}

export const remoteImg = (path: string) => CDN_BASE_URL.img + path;

// This exports the plugin object.
export const plugin = {
  install(Vue: typeof _Vue, options: any) {
    Vue.prototype.$remoteImg = remoteImg;
  }
};
